import { render, staticRenderFns } from "./UseSvg.vue?vue&type=template&id=38f27a91&scoped=true"
import script from "./UseSvg.vue?vue&type=script&lang=js"
export * from "./UseSvg.vue?vue&type=script&lang=js"
import style0 from "./UseSvg.vue?vue&type=style&index=0&id=38f27a91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f27a91",
  null
  
)

export default component.exports